<!--
 * @Description: 课程相关
 * @Author: hanyu
 * @Date: 2020-09-20 16:21:21
 * @LastEditTime: 2020-09-28 16:40:59
 * @LastEditors: hanyu
-->
<template>
  <div class="root">
    <!-- 首页、全部课程 等 、个人中心 -->
    <MainHeader />
    <!-- 浮动客服 -->
    <FloatCustomerService ref="floatCustomerService" />
    <!-- 登录弹窗 -->
    <Account ref="accountRef" />
    <nuxt keep-alive :keep-alive-props="{ include: includeArr }" />
    <IndexFooter />
  </div>
</template>

<script>
import MainHeader from '@/components/header/main-header';
import Account from '@/components/account';
import FloatCustomerService from '@/components/float-customer-service';
import IndexFooter from '@/components/index-footer';

export default {
  name: 'CourseLayout',
  components: {
    MainHeader, Account, FloatCustomerService, IndexFooter
  },
  filters: {},
  props: {},
  data () {
    return {
      includeArr: ['Teacher']
    };
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  activated () {
  },
  methods: {
  }
};
</script>
<style lang='less' scoped>
</style>
